/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useState, useContext } from 'react';
import { convertEnergyDisaggregationTableChart } from '../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import {
  IAny,
  IEmaasEnergyUsageComponentDataV2
} from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import './EnergyConsumptionByEquipmentTypeDetail.scss';
import EnergyConsumptionByEquipmentTypeTable from '../../../../shared/DetailEnergyConsumptionByEquipmentType/EnergyConsumptionByEquipmentTypeTable';
import {
  checkStartEndDateDays,
  checkStartEndDateHourly,
  checkStartEndDateMonth
} from '../../../../shared/Utils/Utils';
import { IntervalType } from '../../../../shared/Utils/Constants';
import { getIntervalTypeForEnergyDisaggregation } from '../../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import { ApiContext } from '../../../../../context/ApiContext';
import { useTranslation } from '@scuf/localization';

export interface IEnergyScopeSavingsByMeterDetailComponentProps {
  data: IEmaasEnergyUsageComponentDataV2;
  UtilityBillType: string;
  requestContext?: IAny;
}

export const energyConsumptionByEquipmentTypeDetail = (
  props: IEnergyScopeSavingsByMeterDetailComponentProps
) => {
  const [t, lng] = useTranslation();
  const { data, requestContext } = props;

  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;

  const { nilmAggregation, energyMeasurementUnit } = data;
  const [nilmTableData] = useState(
    convertEnergyDisaggregationTableChart(
      nilmAggregation.energyDisaggregation,
      fromUnit, //energyMeasurementUnit,
      energyMeasurementUnit,
      requestContext,
      lng
    )
  );
  const interValType = getIntervalTypeForEnergyDisaggregation(
    requestContext.context.startTime as string,
    requestContext.context.endTime as string
  );
  let checkStartEndDate: IAny[] | undefined;
  if (interValType === IntervalType.Monthly) {
    checkStartEndDate = checkStartEndDateMonth(
      nilmAggregation.energyDisaggregation,
      requestContext
    );
  } else if (interValType === IntervalType.Daily) {
    checkStartEndDate = checkStartEndDateDays(
      nilmAggregation.energyDisaggregation,
      requestContext
    );
  } else {
    checkStartEndDate = checkStartEndDateHourly(
      nilmAggregation.energyDisaggregation,
      requestContext
    );
  }

  return (
    <div className="emaas-Metersaving-details-head">
      <EnergyConsumptionByEquipmentTypeTable
        nilmTableData={nilmTableData}
        energyDisaggregation={checkStartEndDate as IAny}
        interValType={interValType}
        requestContext={requestContext}
      />
    </div>
  );
};
export default memo(energyConsumptionByEquipmentTypeDetail);
